// Внешние ссылки открываются в новой вкладке; внутренние и tel: — как обычно
export const externalLinkProps = (href: string) =>
	/^https?:\/\//.test(href)
		? { target: "_blank", rel: "noopener noreferrer" }
		: {};
